<template>
  <v-layout row justify-center>
    <v-dialog ref="dialog" v-model="dialog"  max-width="600px">
      <!--<v-btn slot="activator" color="primary" dark>Open Dialog</v-btn>-->
      <v-toolbar>
        <v-toolbar-title v-if="eventPromotion !== null">Reservas el {{ eventPromotion.slot.format('LLL') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>

        <v-btn icon light @click="dialog = false" >
          <v-icon>close</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card id="card">
        <v-card-text v-if="eventPromotion !== null">
          <v-progress-linear v-show="loading" :indeterminate="true" :active=loading color="#1fabe2"></v-progress-linear>

          <h4>Reservas:</h4>
          <template>
            <v-snackbar
                v-model="snackbar"
                :bottom="true"
                absolute
                :timeout="snackbarTimeout"
                :vertical="'vertical'">
              {{ snackbarText }}
              <v-btn color="pink" flat @click="snackbar = false">
                Close
              </v-btn>
            </v-snackbar>
          <v-expansion-panel v-model="reservesExpansionPanel" >
            <v-expansion-panel-content v-for="(reserve, index) in eventPromotion.reserves" expand :key="`reserve_${index}`">
              <div slot="header">
                <b>{{ reserve.name }}</b> • <span v-if="reserve.phone !== null && reserve.phone !== 0"><v-icon small light>phone</v-icon> {{ reserve.phone }}</span>
                <br />
                <div style="color: grey;"><v-icon small light>mail</v-icon> {{ reserve.mail }}</div>
              </div>
              <div :style="{ backgroundColor: '#fafcfe' }">
                <h3 :style="{ marginLeft: '10px', paddingTop: '8px' }">Modificar reserva:</h3>
                <v-layout :style="{padding: '0 16px', display: 'inline-block', width: '100%'}">
                  <v-flex xs12>
                    <v-select
                        :items="campaigns"
                        v-model="currentOpenedCampaign"
                        label="Campaña"
                        item-text="name"
                        return-object
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                        :items="reserveStatuses"
                        v-model="currentOpenedStatus"
                        label="Estado"
                        item-text="name"
                        return-object
                    ></v-select>
                  </v-flex>

                  <v-flex xs12>
                    <v-select
                        :items="[{id: 'BAJA', name: 'BAJA'},
                                 {id: 'MEDIA', name: 'MEDIA'},
                                 {id: 'ALTA', name: 'ALTA'}]"
                        v-model="currentOpenedIntencion"
                        label="Intención de compra"
                        item-text="name"
                        return-object
                    ></v-select>
                  </v-flex>

                  <v-flex xs12>
                    <v-select
                        :items="[
                                 {id: 'CITA_PERDIDA', name: 'Cita perdida'},
                                 {id: 'CERRADO_PERDIDO', name: 'Cerrado perdido'},
                                 {id: 'CERRADO_GANADO', name: 'Cerrado_ganado'},
                                 {id: 'PENDIENTE_GANADO', name: 'Pendiente ganado ( financiera )'}]"
                        v-model="currentOpenedResult"
                        label="Resultado"
                        item-text="name"
                        return-object
                    ></v-select>
                  </v-flex>

                  <v-flex xs12>
                    <v-select
                        :items="dealers"
                        v-model="currentOpenedDealer"
                        label="Asignar a vendedor"
                        item-text="name"
                        required
                        return-object
                    ></v-select>
                  </v-flex>

                  <v-flex xs12>
                    <v-textarea
                        label="Comentarios"
                        rows="2"
                        v-model="reserve.note"
                    ></v-textarea>
                  </v-flex>

                  <v-flex xs12 text-md-center :style="{marginBottom: '10px'}">

                    <v-btn v-if="!removeActive" riple v-on:click="removeActive = true" v-show="!loading" :style="{backgroundColor: 'red'}" dark>BORRAR RESERVA</v-btn>
                    <div v-else>
                      <v-btn flat value="left" depressed x-small v-on:click="removeActive = false" :disabled=loading>
                        CANCELAR
                      </v-btn>
                      <v-btn flat value="right" color="red" dark v-on:click="deleteReserve(reserve)" >
                        CONFIRMAR BORRAR RESERVA
                      </v-btn>
                    </div>
                    <v-progress-circular color="#1fabe2" indeterminate v-if="loading"></v-progress-circular>
                    <v-btn v-if="!removeActive" v-show="!loading" riple v-on:click="saveReserveChanges(reserve)" :style="{backgroundColor: '#1fabe2'}" dark>GUARDAR CAMBIOS</v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          </template>

          <v-container grid-list-md v-show="eventPromotion.reserves.length < eventPromotion.quantity && !loading && !isReservesExpansionPanelOpened">
            <v-expansion-panel v-model="createReserveExpanded" expand>
              <v-expansion-panel-content>
                <div slot="header">
                  <h4 style="margin-left: -15px; padding-left: 0">Crear reserva:</h4>
                </div>
                <v-layout row wrap :style="{padding: '0 16px'}">
                  <v-flex xs12>
                    <v-text-field
                        v-model="contact.name"
                        label="Nombre y apellidos"></v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    <v-text-field
                        v-model="contact.mail"
                        label="Dirección de mail"
                        required></v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    <v-text-field
                        v-model="contact.phone"
                        label="Teléfono de contacto"
                        required></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                        :items="campaigns"
                        v-model="contact.campaign"
                        label="Campaña"
                        item-text="name"
                        required
                        return-object
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                        :items="dealers"
                        v-model="contact.dealer"
                        label="Asignar a vendedor"
                        item-text="name"
                        required
                        return-object
                    ></v-select>
                  </v-flex>

                  <v-flex xs12>
                    <v-textarea
                        label="Comentarios"
                        rows="2"
                        v-model="contact.note"
                    ></v-textarea>
                  </v-flex>

                  <v-flex xs12 text-md-center>
                    <v-btn v-on:click="createReserve">CREAR RESERVA</v-btn>
                  </v-flex>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-container>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialog = false">Cerrar</v-btn>
          <!--<v-btn color="blue darken-1" flat @click="dialog = false">Save</v-btn>-->
        </v-card-actions>
      </v-card>

    </v-dialog>
  </v-layout>
</template>

<script>
import webservices from '@/utils/webservice'
export default {
  name: 'ReservesVisorComponent',
  props: ['eventPromotion', 'promotionId', 'dealership'],

  data: () => ({
    dialog: false,
    loading: false,
    contact: { name: null, mail: null, phone: null, dealer: null, note: null, campaign: null, intencion: null, result: null },
    removeActive: false,
    snackbar: false,
    snackbarText: null,
    snackbarTimeout: 1000,
    nameRules: [
      v => !!v || 'El nombre es obligatorio'
    ],
    emailRules: [
      v => /.+@.+/.test(v) || 'La dirección de mail no es válida'
    ],
    valid: true,
    reserveStatuses: [],
    removeActives: [],
    dealers: [],
    campaigns: [],
    reserveIntencions: [],
    reserveResults: [],
    createReserveExpanded: [false],
    reservesExpansionPanel: null,
    currentOpenedCampaign: null,
    currentOpenedDealer: null,
    currentOpenedStatus: null,
    currentOpenedIntencion: null,
    currentOpenedResult: null
  }),

  async mounted () {
    this.$on('changeReserveStatus', reserve => {
      this.$nextTick(() => {
        console.log('changeReserveStatus', reserve.status)
      })
    })

    this.reserveStatuses = await webservices.promotions.getReserveStatuses()
    this.campaigns = await webservices.promotions.getPromotionLeadCampaigns()
    //  this.reserveIntencions = await webservices.promotions.getReserveIntencions()
    //  this.reserveResults = await webservices.promotions.getReserveResults()

    if (this.eventPromotion !== null && this.eventPromotion.reserves !== null) {
      this.eventPromotion.reserves = this.eventPromotion.reserves.map(reserve => {
        reserve.status = this.reserveStatuses.find(reserveStatus => reserveStatus.id === reserve.status)
        if (reserve.leadSource !== null) {
          reserve.campaign = this.campaigns.find(campaign => campaign.id === reserve.leadSource.id)
        }
        return reserve
      })
    }
  },

  computed: {
    isReservesExpansionPanelOpened () {
      return this.reservesExpansionPanel !== null
    }
    //   for (let k in this.reservesExpansionPanel) {
    //     if (this.reservesExpansionPanel.hasOwnProperty(k) && this.reservesExpansionPanel[k]) {
    //       return true
    //     }
    //   }
    //   return false
    //  }
  },

  watch: {
    dialog (value) {
      if (!value) {
        this.$emit('close')
      }
    },
    eventPromotion (value) {
      if (value.reserves.length === 0) {
        this.createReserveExpanded = [true]
      } else {
        this.createReserveExpanded = [false]
      }
    },
    dealership (value) {
      console.log('dealership changed', value)
      if (value !== null) {
        this.refreshDealersInfo()
      }
    },
    reservesExpansionPanel (newValue) {
      if (newValue === null) {
        this.currentOpenedCampaign = null
        this.currentOpenedDealer = null
        this.currentOpenedStatus = null
        this.currentOpenedIntencion = null
        this.currentOpenedResult = null
        return
      }

      console.log(`Opened index: ${this.reservesExpansionPanel} newValue: ${newValue}`)
      let openedReserve = this.eventPromotion.reserves[newValue]
      this.currentOpenedDealer = this.dealers.find(dealer => dealer.id === openedReserve.dealer.id)
      this.eventPromotion.reserves[newValue].dealer = this.dealers.find(dealer => dealer.id === openedReserve.dealer.id)
      this.currentOpenedStatus = this.reserveStatuses.find(reserveStatus => reserveStatus.id === openedReserve.status.id)
      this.currentOpenedIntencion = openedReserve.intencion
      this.currentOpenedResult = openedReserve.result
      switch (openedReserve.result) {
        case 'CITA_PERDIDA':
          this.currentOpenedResult = 'Cita perdida'
          break
        case 'CERRADO_PERDIDO':
          this.currentOpenedResult = 'Cerrado perdido'
          break
        case 'CERRADO_GANADO':
          this.currentOpenedResult = 'Cerrado_ganado'
          break
        case 'PENDIENTE_GANADO':
          this.currentOpenedResult = 'Pendiente ganado ( financiera )'
          break
      }
      if (openedReserve.leadSource !== null) {
        this.currentOpenedCampaign = this.campaigns.find(campaign => campaign.id === openedReserve.leadSource.id)
      }
      this.eventPromotion.reserves[newValue].status = this.reserveStatuses.find(reserveStatus => reserveStatus.id === openedReserve.status.id)
      console.log('Opened reserve', { openedReserve, dealers: this.dealers })
    }
  },

  methods: {

    refreshDealersInfo () {
      webservices.promotions.getDealersByPromotionDealership(this.dealership.id, this.promotionId).then(dealers => {
        this.dealers = dealers.map(dealer => {
          dealer.name = `${dealer.name} (${dealer.reserves} reservas)`
          return dealer
        })
      })
    },

    saveReserveChanges (reserve) {
      this.loading = true
      webservices.promotions.updateReserve(reserve.id, {
        statusId: this.currentOpenedStatus.id,
        dealerId: this.currentOpenedDealer.id,
        leadCampaign: this.currentOpenedCampaign !== null ? this.currentOpenedCampaign.id : null,
        //  intencionId: this.currentOpenedIntencion !== null ? this.currentOpenedIntencion.id : null,
        //  resultId: this.currentOpenedResult !== null ? this.currentOpenedResult.id : null,
        note: reserve.note
      }).then(result => {
        let index = this.eventPromotion.reserves.indexOf(reserve)
        this.eventPromotion.reserves[index].dealer = this.currentOpenedDealer
        this.eventPromotion.reserves[index].status = this.currentOpenedStatus
        //  this.eventPromotion.reserves[index].intencion = this.currentOpenedIntencion
        //  this.eventPromotion.reserves[index].result = this.currentOpenedResult
        this.eventPromotion.reserves[index].leadSource = this.currentOpenedCampaign
        this.snackbarText = `Reserva actualizada correctamente`
        this.snackbar = true
        this.closeReservesExpansionPanels()
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.loading = false
        this.currentOpenedDealer = null
        this.currentOpenedStatus = null
        //  this.currentOpenedIntencion = null
        //  this.currentOpenedResult = null
        this.currentOpenedCampaign = null
        this.refreshDealersInfo()
      })

      webservices.promotions.updateReserveIntencionResult({
        reserveId: reserve.id,
        intencionId: this.currentOpenedIntencion !== null ? this.currentOpenedIntencion.id : null,
        resultId: this.currentOpenedResult !== null ? this.currentOpenedResult.id : null
      }).then(result => {
        this.eventPromotion.reserves.intencion = this.currentOpenedIntencion
        this.eventPromotion.reserves.result = this.currentOpenedResult
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.currentOpenedIntencion = null
        this.currentOpenedResult = null
      })
    },

    onReserveStatusChange (reserve) {
      this.$nextTick(() => {
        this.loading = true
        webservices.promotions.updateReserveStatus(reserve.id, reserve.status).then(result => {
          console.log('Update reserve status result', result)
        }).catch(e => {
          console.error(e)
        }).finally(() => {
          this.loading = false
        })
      })
    },

    deleteReserve (reserve) {
      this.loading = true
      webservices.promotions.deleteReserve(reserve.id).then(result => {
        if (result.hasOwnProperty('removed') && result.removed) {
          let reserveIndex = this.eventPromotion.reserves.indexOf(reserve)
          if (reserveIndex > -1) {
            this.eventPromotion.reserves.splice(reserveIndex, 1)
            this.removeActive = false
          }
        }
      }).catch(({ response }) => {
        this.snackbar = true
        this.snackbarText = response.data.error
      }).finally(() => {
        this.loading = false
      })
    },
    createReserve () {
      if (this.contact.name === null || this.contact.name.length === 0) {
        alert('El nombre del contacto no puede estar vacío')
        return false
      }

      if ((this.contact.mail === null && this.contact.phone === null) || (this.contact.mail === '' && this.contact.phone === '')) {
        alert('Debes especificar un email o teléfono de contacto válido')
        return false
      }

      if (this.contact.dealer === null) {
        alert('Debes asignarle la reserva a un comercial')
        return false
      }

      if (this.contact.campaign === null || this.contact.campaign === undefined) {
        alert('Debes elegir una campaña')
        return false
      }

      this.loading = true
      //  console.log(this.eventPromotion)
      //  process.env.PROMO_CODE, this.promoDealership.id, this.slot
      webservices.promotions.createReserve(this.promotionId, this.dealership.id, this.eventPromotion.slot.toDate().getTime(), {
        name: this.contact.name,
        mail: this.contact.mail,
        phone: this.contact.phone,
        note: this.contact.note,
        dealerId: this.contact.dealer.id,
        source: this.$store.state.app.session.payload.dealer.id,
        leadSource: this.contact.campaign !== null && this.contact.campaign !== undefined ? this.contact.campaign.id : null
      }).then(result => {
        if (result instanceof Array && result.length > 0) {
          this.resetContactForm()
          this.snackbarText = '! RESERVA CREADA CORRECTAMENTE !'
          this.snackbar = true
          setTimeout(() => {
            this.snackbar = false
          }, 1500)
          let reserve = result[0].reserves[result[0].reserves.length - 1]
          this.eventPromotion.reserves.push(reserve)
          this.createReserveExpanded = [false]
        }
      }).catch(({ response }) => {
        if (response.status === 409) {
          this.snackbar = true
          this.snackbarText = response.data.error
          setTimeout(() => {
            this.snackbar = false
          }, 4000)
        }
      }).finally(() => {
        this.loading = false
        this.refreshDealersInfo()
      })
    },
    open () {
      this.dialog = true
      this.removeActive = false
      this.resetContactForm()
      this.reservesExpansionPanel = null
      this.closeReservesExpansionPanels()
    },

    closeReservesExpansionPanels () {
      this.reservesExpansionPanel = null
    },

    resetContactForm () {
      this.contact = { name: null, mail: null, phone: null, dealer: null, note: null }
    },

    close () {
      this.resetContactForm()
      this.dialog = false
      this.eventPromotion = null
      this.createReserveExpanded = [false]
    },
    clickRiple () {
      console.log('clickRiple')
    }
  }
}
</script>

<style lang="scss">
  .v-text-field__slot input[type="text"] {
    padding-left: 10px;
  }

  #attach_list {
    position: absolute;
    width:100%;
  }

  #attach_list .v-menu__content {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/custom/ReservesVisorComponent.vue